import { Flex } from '@abyss/web/ui/Flex';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import find from 'lodash/find';

import { ConstantsLagoon } from '../../../../../../common/ConstantsLagoon';
import { useLagoon } from '../../../../../../hooks/useLagoon';
import { useSmartChoice } from '../../../../../../hooks/useSmartChoice';
import { LayoutGroupStyled } from '../../../CompareSmartChoice/CompareSmartChoice.styled';
import {
  IconWithText,
  PrintViewDivider,
  PrintViewProviderDetailsXSText,
  Section,
} from './PrintExpandedCardStyle.styled';
import { PrintHoursOfOperation } from './PrintHoursOfOperation';

export const PrintExpandedConvenienceCard = ({
  selectedAttributes,
  selectedProviders,
  preferencesData,
}) => {
  const isSmartChoice = useSmartChoice();

  const lagoonData = useLagoon('ui-messaging')();
  const accept_new_patients = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE_CONVENIENCE_BREAKDOWN
      .CONVENIENCE_BREAKDOWN_ACCEPCTING_NEW_PATIENTS,
  })?.message;
  const not_accepting_new_patients = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE
      .COMPARE_NOT_ACCEPTING_NEW_PATIENTS,
  })?.message;
  const not_available = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_NOT_AVAILABLE_TEXT,
  })?.message;
  const evening_appointments_available = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE_CONVENIENCE_BREAKDOWN
      .CONVENIENCE_BREAKDOWN_EVENING_APPONTMENTS_AVAILABILE,
  })?.message;
  const evening_appointments_unavailable = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE_CONVENIENCE_BREAKDOWN
      .CONVENIENCE_BREAKDOWN_EVENING_APPONTMENTS_UNAVAILABILE,
  })?.message;
  const weekend_appointments_available = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE_CONVENIENCE_BREAKDOWN
      .CONVENIENCE_BREAKDOWN_WEEKEND_APPONTMENTS_AVAILABILE,
  })?.message;
  const weekend_appointments_unavailable = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE_CONVENIENCE_BREAKDOWN
      .CONVENIENCE_BREAKDOWN_WEEKEND_APPONTMENTS_UNAVAILABILE,
  })?.message;
  const online_appointment_scheduling_available = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE_CONVENIENCE_BREAKDOWN
      .CONVENIENCE_BREAKDOWN_ONLINE_APOINTMENT_SCHEDULE_AVAILABLE_THOUGHT_MYUHC_COM,
  })?.message;
  const online_appointment_scheduling_unavailable = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE_CONVENIENCE_BREAKDOWN
      .CONVENIENCE_BREAKDOWN_ONLINE_APOINTMENT_SCHEDULE_UNAVAILABLE_THOUGHT_MYUHC_COM,
  })?.message;
  const virtual_appointments_available = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE_CONVENIENCE_BREAKDOWN
      .CONVENIENCE_BREAKDOWN_VIRTUAL_APOINTMENTS_AVAILABLE,
  })?.message;
  const virtual_appointments_unavailable = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.SMART_CHOICE_CONVENIENCE_BREAKDOWN
      .CONVENIENCE_BREAKDOWN_VIRTUAL_APOINTMENTS_UNAVAILABLE,
  })?.message;
  const offers_virtual_Care = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_OFFERS_VIRTUAL_CARE,
  })?.message;
  const no_virtual_Care = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.COMPARE.COMPARE_NO_VIRTUAL_CARE,
  })?.message;

  return (
    <Section>
      {selectedAttributes.find(
        (record) => record.name === 'acceptingNewPatients'
      )?.isChecked && (
        <>
          <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
            {selectedProviders?.map((item, index) => (
              <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                {item?.acceptingNewPatients ? (
                  <IconWithText>
                    <IconSymbol color="#007000" icon="done" size={20} />
                    <PrintViewProviderDetailsXSText>
                      {accept_new_patients}
                    </PrintViewProviderDetailsXSText>
                  </IconWithText>
                ) : (
                  <PrintViewProviderDetailsXSText>
                    {not_accepting_new_patients}
                  </PrintViewProviderDetailsXSText>
                )}
              </LayoutGroupStyled>
            ))}
          </LayoutGroupStyled>
          <LayoutGroupStyled
            css={{ '& > div': { width: '100%' } }}
            cssProps={{ minHeightAuto: true }}
            grow
          >
            {selectedProviders?.map((_, index) => (
              <PrintViewDivider key={index} orientation="horizontal" />
            ))}
          </LayoutGroupStyled>
        </>
      )}
      {/* HOURS OF OPERATION */}
      {selectedAttributes.find((record) => record.name === 'hoursOfOperation')
        ?.isChecked &&
        !isSmartChoice && (
          <>
            <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
              {selectedProviders?.map((item, index) => (
                <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                  <PrintHoursOfOperation
                    isUsedInCompare={true}
                    not_available={not_available}
                    selectedProvider={item}
                  />
                </LayoutGroupStyled>
              ))}
            </LayoutGroupStyled>
            <LayoutGroupStyled
              css={{ '& > div': { width: '100%' } }}
              cssProps={{ minHeightAuto: true }}
              grow
            >
              {selectedProviders?.map((_, index) => (
                <PrintViewDivider key={index} orientation="horizontal" />
              ))}
            </LayoutGroupStyled>
          </>
        )}
      {selectedAttributes.find(
        (record) => record?.name === 'appointmentAvailability'
      )?.isChecked &&
        isSmartChoice && (
          <>
            <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
              {selectedProviders?.map((item, index) => (
                <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                  <PrintHoursOfOperation
                    not_available={not_available}
                    selectedProvider={item}
                  />
                </LayoutGroupStyled>
              ))}
            </LayoutGroupStyled>
            <LayoutGroupStyled
              css={{ '& > div': { width: '100%' } }}
              cssProps={{ minHeightAuto: true }}
              grow
            >
              {selectedProviders?.map((_, index) => (
                <PrintViewDivider key={index} orientation="horizontal" />
              ))}
            </LayoutGroupStyled>
          </>
        )}

      {selectedAttributes.find(
        (record) => record.name === 'hasEveningAppointments'
      )?.isChecked &&
        ((isSmartChoice && preferencesData?.evngApptAvbl === 'y') ||
          !isSmartChoice) && (
          <>
            <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
              {selectedProviders?.map((item, index) => (
                <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                  {item?.hasEveningAppointments ? (
                    <IconWithText>
                      <IconSymbol color="#007000" icon="done" size={20} />
                      <PrintViewProviderDetailsXSText>
                        {evening_appointments_available}
                      </PrintViewProviderDetailsXSText>
                    </IconWithText>
                  ) : (
                    <PrintViewProviderDetailsXSText>
                      {evening_appointments_unavailable}
                    </PrintViewProviderDetailsXSText>
                  )}
                </LayoutGroupStyled>
              ))}
            </LayoutGroupStyled>
            <LayoutGroupStyled
              css={{ '& > div': { width: '100%' } }}
              cssProps={{ minHeightAuto: true }}
              grow
            >
              {selectedProviders?.map((_, index) => (
                <PrintViewDivider key={index} orientation="horizontal" />
              ))}
            </LayoutGroupStyled>
          </>
        )}

      {selectedAttributes.find(
        (record) => record.name === 'hasWeekendAppointment'
      )?.isChecked &&
        ((isSmartChoice && preferencesData?.wkndApptAvbl === 'y') ||
          !isSmartChoice) && (
          <>
            <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
              {selectedProviders?.map((item, index) => (
                <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                  {item?.hasWeekendAppointment ? (
                    <IconWithText>
                      <IconSymbol color="#007000" icon="done" size={20} />
                      <PrintViewProviderDetailsXSText>
                        {weekend_appointments_available}
                      </PrintViewProviderDetailsXSText>
                    </IconWithText>
                  ) : (
                    <PrintViewProviderDetailsXSText>
                      {weekend_appointments_unavailable}
                    </PrintViewProviderDetailsXSText>
                  )}
                </LayoutGroupStyled>
              ))}
            </LayoutGroupStyled>
            <LayoutGroupStyled
              css={{ '& > div': { width: '100%' } }}
              cssProps={{ minHeightAuto: true }}
              grow
            >
              {selectedProviders?.map((_, index) => (
                <PrintViewDivider key={index} orientation="horizontal" />
              ))}
            </LayoutGroupStyled>
          </>
        )}

      {selectedAttributes.find(
        (record) => record.name === 'onlineAppointmentScheduling'
      )?.isChecked &&
        ((isSmartChoice &&
          preferencesData?.onlineApptSchdlAvbl?.toLowerCase() === 'y') ||
          !isSmartChoice) && (
          <>
            <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
              {selectedProviders?.map((item, index) => (
                <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                  {item?.recommendationDetails?.convenience
                    ?.onlineAppointmentScheduling === 'Y' ? (
                    <IconWithText>
                      <IconSymbol color="#007000" icon="done" size={20} />
                      <PrintViewProviderDetailsXSText>
                        {online_appointment_scheduling_available}
                      </PrintViewProviderDetailsXSText>
                    </IconWithText>
                  ) : (
                    <PrintViewProviderDetailsXSText>
                      {online_appointment_scheduling_unavailable}
                    </PrintViewProviderDetailsXSText>
                  )}
                </LayoutGroupStyled>
              ))}
            </LayoutGroupStyled>
            <LayoutGroupStyled
              css={{ '& > div': { width: '100%' } }}
              cssProps={{ minHeightAuto: true }}
              grow
            >
              {selectedProviders?.map((_, index) => (
                <PrintViewDivider key={index} orientation="horizontal" />
              ))}
            </LayoutGroupStyled>
          </>
        )}
      {selectedAttributes.find((record) => record.name === 'virtualCareOffered')
        ?.isChecked &&
        (isSmartChoice && preferencesData?.virtualApptAvbl === 'y' ? (
          <>
            <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
              {selectedProviders?.map((item, index) => (
                <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                  {item?.recommendationDetails?.convenience
                    ?.virtualAppointments === 'Y' ? (
                    <IconWithText>
                      <IconSymbol color="#007000" icon="done" size={20} />
                      <PrintViewProviderDetailsXSText>
                        {virtual_appointments_available}
                      </PrintViewProviderDetailsXSText>
                    </IconWithText>
                  ) : (
                    <PrintViewProviderDetailsXSText>
                      {virtual_appointments_unavailable}
                    </PrintViewProviderDetailsXSText>
                  )}
                </LayoutGroupStyled>
              ))}
            </LayoutGroupStyled>
            <LayoutGroupStyled
              css={{ '& > div': { width: '100%' } }}
              cssProps={{ minHeightAuto: true }}
              grow
            >
              {selectedProviders?.map((_, index) => (
                <PrintViewDivider key={index} orientation="horizontal" />
              ))}
            </LayoutGroupStyled>
          </>
        ) : (
          <>
            <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
              {selectedProviders?.map((item, index) => (
                <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                  {item?.virtualCareOffered?.length ? (
                    <IconWithText>
                      <IconSymbol color="#007000" icon="done" size={20} />
                      <PrintViewProviderDetailsXSText>
                        {offers_virtual_Care}
                      </PrintViewProviderDetailsXSText>
                    </IconWithText>
                  ) : (
                    <PrintViewProviderDetailsXSText>
                      {no_virtual_Care}
                    </PrintViewProviderDetailsXSText>
                  )}
                </LayoutGroupStyled>
              ))}
            </LayoutGroupStyled>
            <LayoutGroupStyled
              css={{ '& > div': { width: '100%' } }}
              cssProps={{ minHeightAuto: true }}
              grow
            >
              {selectedProviders?.map((_, index) => (
                <PrintViewDivider key={index} orientation="horizontal" />
              ))}
            </LayoutGroupStyled>
          </>
        ))}

      {selectedAttributes.find((record) => record.name === 'distance')
        ?.isChecked && (
        <>
          <LayoutGroupStyled css={{ '& > div': { width: '100%' } }} grow>
            {selectedProviders?.map((item, index) => (
              <LayoutGroupStyled css={{ alignItems: 'center' }} key={index}>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <PrintViewProviderDetailsXSText>
                    {item?.address?.line[0]}, {item?.address?.city},{' '}
                    {item?.address?.state}
                  </PrintViewProviderDetailsXSText>

                  <Flex css={{ marginTop: 8, alignItems: 'center' }}>
                    <IconSymbol
                      color="$gray7"
                      icon="directions"
                      size={20}
                      style={{ marginRight: 4 }}
                      variant="outlined"
                    />
                    <PrintViewProviderDetailsXSText>
                      {parseFloat(item?.distance)?.toFixed(2)} mi{' '}
                    </PrintViewProviderDetailsXSText>
                  </Flex>
                </div>
              </LayoutGroupStyled>
            ))}
          </LayoutGroupStyled>
          {!isSmartChoice && (
            <LayoutGroupStyled
              css={{ '& > div': { width: '100%' } }}
              cssProps={{ minHeightAuto: true }}
              grow
            >
              {selectedProviders?.map((_, index) => (
                <PrintViewDivider key={index} orientation="horizontal" />
              ))}
            </LayoutGroupStyled>
          )}
        </>
      )}
    </Section>
  );
};
